import React from "react";
import { Stepper, Step, StepLabel, withStyles } from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import styles from "../styles";
import ToolTip from "../../../../common/StyledToolTip";
import OptimizationInfo from "./OptimizationInfo";
import { PICKUP_OPTIMYZER_STEP } from "../constants";

const OptimizationStepper = ({
  classes,
  steps,
  activeStep,
  completed,
  progressPercentage,
}) => {
  return (
    <div className={classes.stepperStyle}>
      <Stepper
        alternativeLabel
        nonLinear
        activeStep={activeStep}
        classes={{
          root: classes.rootstep,
        }}
        id="Stepper"
      >
        {steps.map((label, index) => {
          return (
            <Step key={label}>
              <StepLabel
                completed={completed[index]}
                StepIconProps={{
                  classes: { root: classes.stepIconStyle },
                }}
                classes={{
                  label: classes.labelStyle,
                  active: classes.activeLabelStyle,
                  completed: classes.activeLabelStyle,
                }}
              >
                {label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {activeStep === PICKUP_OPTIMYZER_STEP.CORRECT_PICKUP_INFO && progressPercentage === 0 && (
        <ToolTip title={<OptimizationInfo />}>
          <HelpOutlineIcon className={classes.infoIcon}></HelpOutlineIcon>
        </ToolTip>
      )}
    </div>
  );
};
export default withStyles(styles)(OptimizationStepper);
